import React from 'react'
import { CiBatteryEmpty } from "react-icons/ci";
import { BsDatabaseFillX } from "react-icons/bs";

const NoDataFound = ({children , msg}) => {
    return (
        <div className='h-full w-full mx-auto flex flex-col items-center justify-center rounded-xl bg-[#EBF9D9] text-[#3d297c] font-bold text-center p-7 my-2 '>
            <div className='flex justify-between gap-2 items-center'>
                <BsDatabaseFillX size={30} />
                <span className='pt-1 text-[20px]'>{msg}</span>
            </div>
            {
                children && 
                <div className='my-2'>
                    {children}
                </div>
            }
        </div>
    )
}

export default NoDataFound